import { Form, Input } from 'antd';
import React, { memo } from 'react';
import { useTheme } from 'styled-components';
import { CommercialInvoiceBaseProps } from 'types';
import { FormItem, HiddenField } from '@xbcb/form-item-components';
import { getCodes } from '@xbcb/ui-utils';
import { hasLicenseNumberRequirement } from 'libs/entryValidation';

export interface LineItemLicenseInfoTabProps
  extends CommercialInvoiceBaseProps {
  licenseCode: string;
}

/**
 * LineItemLicenseInfoTab
 *
 * The License Info tab for line items.
 */

export const LineItemLicenseInfoTab: React.FC<LineItemLicenseInfoTabProps> = ({
  fullNamePath,
  localNamePath,
  disabled,
  readOnly,
  required,
  licenseCode,
}: LineItemLicenseInfoTabProps) => {
  const theme = useTheme();
  const codes = getCodes();
  const { CBP } = codes;
  const { CATAIR } = CBP;
  const licenseCodes = CATAIR.license;
  const form = Form.useFormInstance();

  return (
    <>
      <HiddenField
        localNamePath={[...localNamePath, 'licenseCode']}
        value={licenseCode}
        fullNamePath={[...fullNamePath, 'licenseCode']}
        form={form}
      />
      <FormItem
        $itemSize={theme.size.medium}
        label={`${licenseCodes[licenseCode]} Number`}
        name={[...localNamePath, 'licenseNumber']}
        rules={[
          {
            required: required && hasLicenseNumberRequirement(licenseCode),
            message: ' ',
          },
        ]}
        $readOnly={readOnly}
        debounce
      >
        <Input disabled={disabled} />
      </FormItem>
    </>
  );
};

export default memo(LineItemLicenseInfoTab);
